import { render, staticRenderFns } from "./noowner.vue?vue&type=template&id=d8bf7a1a&scoped=true"
import script from "./noowner.vue?vue&type=script&lang=js"
export * from "./noowner.vue?vue&type=script&lang=js"
import style0 from "./noowner.vue?vue&type=style&index=0&id=d8bf7a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bf7a1a",
  null
  
)

export default component.exports